import { Link } from "gatsby"
import PropTypes from "prop-types"
import React from "react"
import { AppBar, ButtonGroup, Button, Typography } from '@material-ui/core';

import '../styles/header.scss';

const Header = ({ siteTitle, navNumber }) => (
  <>
    <div className="dev">
      <div>
        <span>Due to back-end server costs, <b>I've shut it down</b>.</span>
      </div>
      <div>If you wanna know the way how this web-app worked, please watch the video in the index page!</div>
    </div>
    <header
      style={{
        background: `#0d0d0d`,
        marginBottom: `1.45rem`,
        border: '5px solid rgba(193, 27, 31, 0.5)',
      }}
    >
      <div
        style={{
          margin: `0 auto`,
          maxWidth: 960,
          padding: `2.54rem 1.0875rem`,
        }}
      >
        <div style={{ margin: 0, fontFamily: 'st', fontSize: "2.2rem", fontWeight: "bold" }}>
          <Link
            to="/"
            style={{
              color: `#C11B1F`,
              textDecoration: `none`,
              marginRight: 7
            }}
          >
            {siteTitle}
          </Link>
          <Typography variant="caption" color="secondary">v0.1.2</Typography>
        </div>
      </div>

      {/* <AppBar className="appbar ab1" component="div" variant="outlined" position="sticky" color="secondary">
      <ButtonGroup fullWidth className="btn-group" color="primary" variant="outlined">
        <Button variant={navNumber===4?"contained":"outlined"}><Link to="/stranger-things-wiki">Wiki</Link></Button>
        // <Button variant="outlined"></Button>
        <Button variant={navNumber===5?"contained":"outlined"}><Link to="/stranger-things-music">Music</Link></Button>
      </ButtonGroup>
    </AppBar> */}

      <AppBar className="appbar ab2" component="div" variant="outlined" position="sticky" color="secondary">
        <ButtonGroup fullWidth className="btn-group" color="primary" variant="outlined">
          <Button variant={navNumber === 1 ? "contained" : "outlined"}><Link to="/stranger-things-quiz">Quiz</Link></Button>
          <Button variant={navNumber === 3 ? "contained" : "outlined"}><Link to="/stranger-things-face-similarity">Face Similarity</Link></Button>
          <Button variant={navNumber === 2 ? "contained" : "outlined"}><Link to="/stranger-things-avatar-generator">Avatar Generator</Link></Button>
        </ButtonGroup>
      </AppBar>
    </header>
  </>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
  navNumber: PropTypes.number.isRequired,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
